module.exports = __webpack_public_path__ + "static/img/avatar.db57a256.png";